import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../components/messages/ErrorMessage';
import { useCompanyContext } from '../../../context/CompanyContext';
import { fetchPolicies } from '../../../services/Insurance/Policy';
import PoliciesTable from './PoliciesTable';
import { usePolicySummaryContext } from './PolicyContext';
import { PolicyFiltersOptions } from './PolicyFilters';
import { useFormContext } from 'react-hook-form';

const PoliciesTableContainer = React.forwardRef<HTMLDivElement>(() => {
  const { selectedCompany } = useCompanyContext();
  const { data, setData } = usePolicySummaryContext();
  const { watch } = useFormContext<PolicyFiltersOptions>();
  const filters = watch();

  const { isFetching, isError } = useQuery({
    queryKey: ['getPolicies', selectedCompany, filters.policyStatus],
    queryFn: ({ signal }) => {
      return fetchPolicies(selectedCompany!.id, filters.policyStatus, signal);
    },
    onSuccess: (policies) => {
      setData(policies);
    },
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
  });

  if (isFetching || !selectedCompany)
    return (
      <div className="text-center mx-auto mt-3">
        <ProgressSpinner />
      </div>
    );

  if (isError)
    return (
      <ErrorMessage
        content={'Failed to obtain data! Please try again later.'}
      />
    );

  return <PoliciesTable policies={data} />;
});

export default PoliciesTableContainer;
